import A11YLink from './A11YLink.js';

export default A11YLink;
